// @flow
import React from 'react';
import Ellipsis from '@localytics/loc-components/lib/Ellipsis';
import Overlay from 'react-bootstrap/lib/Overlay';
import { ActionMenu } from '@localytics/loc-components/lib/ActionMenuContainers';
import ActionMenuItem from '@localytics/loc-components/lib/ActionMenuItem';
import { downloadPerformanceCSV } from '../util/ApiUtils';

type ActionMenuProps = {
  deleteOrchestration: Function,
  downloadCSV: Function,
  showDownload: boolean
};

const OrchestrationActionMenu = (props: ActionMenuProps) => {
  const { deleteOrchestration, downloadCSV, showDownload } = props;
  return (
    <ActionMenu {...props}>
      {showDownload ? (
        <ActionMenuItem
          title="Download .CSV"
          className="OrchestrationTable__ActionMenuItem"
          onClick={downloadCSV}
        />
      ) : null}
      <ActionMenuItem
        title="Delete"
        className="OrchestrationTable__ActionMenuItem"
        onClick={deleteOrchestration}
      />
    </ActionMenu>
  );
};

type TableActionMenuPropTypes = {
  orchData: {
    orgId: number,
    orchId: number,
    name: string,
    hasOnlyDraftVersions: boolean
  },
  deleteOrchestration: Function
};

type TableActionMenuStateTypes = {
  show: boolean
};

export default class TableActionMenu extends React.Component<
  TableActionMenuPropTypes,
  TableActionMenuStateTypes
> {
  constructor(props: TableActionMenuPropTypes) {
    super(props);
    this.state = {
      show: false
    };
    this.toggleOverlay = this.toggleOverlay.bind(this);
  }

  target: ?HTMLDivElement;

  toggleOverlay: Function = () => {
    this.setState({
      show: !this.state.show
    });
  };

  render() {
    const { orchData, deleteOrchestration } = this.props;
    const { show } = this.state;
    const { orgId, orchId, name, hasOnlyDraftVersions } = orchData;
    return (
      <div
        ref={div => {
          this.target = div;
        }}
      >
        <Overlay
          show={show}
          onHide={this.toggleOverlay}
          placement="left"
          target={this.target}
          rootClose
        >
          <OrchestrationActionMenu
            downloadCSV={() => {
              this.toggleOverlay();
              downloadPerformanceCSV(orgId, orchId, name);
            }}
            deleteOrchestration={() => {
              this.toggleOverlay();
              /* eslint-disable */
              if (
                confirm(
                  'Are you sure you want to delete this workflow? All active versions will be disabled and all users in the workflow will exit.'
                )
              ) {
                deleteOrchestration(orgId, orchId);
              }
              /* eslint-enable */
            }}
            showDownload={!hasOnlyDraftVersions}
          />
        </Overlay>
        <Ellipsis onClick={this.toggleOverlay} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TableActionMenu.jsx